import { render, staticRenderFns } from "./PrisonerPoints.vue?vue&type=template&id=320dccd0"
import script from "./PrisonerPoints.vue?vue&type=script&lang=js"
export * from "./PrisonerPoints.vue?vue&type=script&lang=js"
import style0 from "./PrisonerPoints.vue?vue&type=style&index=0&id=320dccd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports